import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import * as React from "react";
import { QuestionAccordion } from "./QuestionAccordion";

export const QuestionQuickViewDialog = ({ open, setOpen, question }) => {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth={"md"}
      slotProps={{
        paper: {
          sx: {
            backgroundImage: "none",
            height: "90vh",
            display: "flex",
            flexDirection: "column",
          },
        },
      }}
    >
      <DialogTitle>Question quick view</DialogTitle>

      <DialogContent>
        <QuestionAccordion question={question} defaultExpanded />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant={"contained"}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
